import { message } from 'antd';
import { get } from 'lodash';

import { COPYWRITE } from './constant';

export default function handleError(error = {}) {
  message.error(get(error, ['response', 'message'], COPYWRITE.ERROR_FALLBACK));
}
